// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Photos__row":"tf_a bhu_a bhu_r bhu_j","Photos__img":"tf_b bhu_b"};